import { Box, Stack, Typography, styled, useTheme } from "@mui/material";
import { ProgressTimelineDot } from "./ProgressTimelineDot";
import { useTranslations } from "next-intl";

interface HorizontalProgressTimelineItemProps {
  isActive: boolean;
  isCompleted: boolean;
  title: string;
  subTitle: string;
  hideConnector?: boolean;
}

export const HorizontalProgressTimelineItem = ({
  isActive,
  isCompleted,
  title,
  subTitle,
  hideConnector,
}: HorizontalProgressTimelineItemProps) => {
  const theme = useTheme();
  const t = useTranslations();
  return (
    <Box display="flex" gap={3}>
      <Stack
        justifyContent="center"
        alignItems="center"
        position="relative"
        pt={0.3}
      >
        {!hideConnector && (
          <Box
            position="absolute"
            height="120%"
            width="0.125rem"
            borderRadius="0.125rem"
            top="-80%"
            zIndex={0}
            bgcolor={
              isActive || isCompleted
                ? theme.palette.primary.main
                : theme.palette.grey[300]
            }
          />
        )}

        <ProgressTimelineDot isCompleted={isCompleted} isActive={isActive} />
      </Stack>
      <Stack width="100%">
        <Typography
          color={isActive ? "primary" : "grey.200"}
          fontSize="0.875rem"
          fontWeight="700"
          mt={0.4}
        >
          {t(title)}
        </Typography>
        <Typography color="grey.200" fontSize="0.875rem">
          {t(subTitle)}
        </Typography>
      </Stack>
    </Box>
  );
};
